const reports = {
  main: {
    btn: 'הצג'
  },
  filterForm: {
    filter: 'סינון',
    export: 'ייצא',
    validation: {
      reportTypeRequired: 'סוג דוח נדרש',
      startDateRequired: 'תאריך התחלה נדרש',
      endDateRequired: 'תאריך סיום נדרש',
    },
    form: {
      reportType: {
        label: 'סוג דוח',
        reportTypeOptions: {
          selectReport: 'בחר דוח',
          shuttlePassangers: 'נוסעי שאטל',
          dailySummary: 'סיכום יומי',
          delaysReport: 'דוח עיכובים',
          shuttleReport: 'דוח שאטל',
          vehicleOccupancy: 'תפוסת רכב',
          commuterSatisfaction: 'שביעות רצון נוסעים',
          passengerCostPareto: 'עלות נוסע - פארטו',
          carbonEfficiency: 'יעילות פחמן',
          totalTripsPassengers: ' Total Trips/Passengers',
        },
      },
      selectShuttle: 'בחר שאטל',
      dateStart: 'תאריך התחלה',
      dateEnd: 'תאריך סיום',
    },
  },
};

export default reports;
